export const LUX_PLUS_MONTH_TAKEOVER_ID = 'lux-plus-month'
export const LUX_PLUS_MONTH_TAKEOVER_REGIONS = new Set(['AU', 'US', 'NZ', 'CA', 'CN', 'SG', 'HK', 'ID', 'IL', 'JP', 'MO', 'KR', 'MY', 'PH', 'QA', 'SA', 'ZA', 'TW', 'TH', 'AE', 'VN', 'FR', 'DE', 'IE', 'IT', 'NL', 'RU', 'ES', 'GB'])
export const LUX_PLUS_MONTH_CAMPAIGN_ID = 'LuxPlus+ month'
export const LUX_PLUS_MONTH_ALL_OFFERS_URL = '/lux-plus'
export const LUX_PLUS_MONTH_LANDING_PAGE_URL = '/campaign/luxplus-member-event'

// Always use the production image host — these campaign assets are only uploaded to the prod bucket
export const LUX_PLUS_MONTH_POOL_IMAGE_URL = 'https://images.luxuryescapes.com/luxplus-month-asset-cce5fc1a4122'

// The home page banner cycles through these three images. Order matches how they were provided:
// the two new assets first, then the existing hero image last.
export const LUX_PLUS_MONTH_HOME_BANNER_IMAGE_URLS = [
  LUX_PLUS_MONTH_POOL_IMAGE_URL,
  'https://images.luxuryescapes.com/luxplus-month-asset-b0b6d015b4cc',
  'https://images.luxuryescapes.com/luxplus-month-asset-6ac1bc5ce2ca',
]

export const LUX_PLUS_MONTH_BLOB_SHAPE_LARGE_RADIUS_PERCENT = '53.38%'
export const LUX_PLUS_MONTH_BLOB_SHAPE_SMALL_RADIUS_PERCENT = '3.2%'
